import React from "react";
import { SlideShell } from "../../../shared/components/SlideShell";

export const Slide12 = ({ t, total, onActive }) => {
  return (
    <SlideShell theme="emissor"
      index={11}
      total={total}
      label="Partner Program A"
      kicker={t.kicker}
      onActive={onActive}
      bgStyle={{
        "--slide-bg": "radial-gradient(760px 540px at 76% 36%,rgba(216,182,46,.22),transparent 68%),linear-gradient(112deg,#020202,#07110d,#020202)"
      }}
    >

      <h2 dangerouslySetInnerHTML={{ __html: t.title }} />
      <p className="lead">{t.body}</p>

      <div className="grid four wide">
        <div className="card">
          <span className="num">01</span>
          <h3>{t.c1Title}</h3>
          <p>{t.c1Body}</p>
        </div>
        <div className="card">
          <span className="num">02</span>
          <h3>{t.c2Title}</h3>
          <p>{t.c2Body}</p>
        </div>
        <div className="card">
          <span className="num">03</span>
          <h3>{t.c3Title}</h3>
          <p>{t.c3Body}</p>
        </div>
        <div className="card">
          <span className="num">04</span>
          <h3>{t.c4Title}</h3>
          <p>{t.c4Body}</p>
        </div>
      </div>

      <p className="body" style={{ marginTop: "28px", maxWidth: "980px" }}>{t.sub1}</p>
      <p className="lead" style={{ fontSize: "28px", maxWidth: "980px", marginTop: "10px" }}>{t.sub2}</p>

      <div className="pillrow">
        <span className="pill">{t.p1}</span>
        <span className="pill">{t.p2}</span>
        <span className="pill">{t.p3}</span>
        <span className="pill">{t.p4}</span>
      </div>
    </SlideShell>
  );
};





